import React, { useState } from "react";
import QrRegisterCheckerModal from "./qrRegisterCheckerModal";
import GetQrCodeRegisteredRanges from "./getQrCodeRegisteredRanges";

const QrLayout = () => {
  const [openQrModal, setOpenQrModal] = useState(false);
  const [refetchData, setRefetchData] = useState(false);

  const handleCancel = () => {
    setOpenQrModal(false);
  };

  const handleOpenQrModal = () => {
    setOpenQrModal(true);
  };

  const toggleRefetchData = () => {
    setRefetchData(!refetchData);
  };

  return (
    <>
      <GetQrCodeRegisteredRanges
        refetchData={refetchData}
        handleOpenQrModal={handleOpenQrModal}
      />
      <QrRegisterCheckerModal
        openQrModal={openQrModal}
        handleCancel={handleCancel}
        toggleRefetchData={toggleRefetchData}
      />
    </>
  );
};

export default QrLayout;
